var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"paperManage",staticClass:"paper-manage"},[_c('left-score-setting',{ref:"leftScoreSetting"}),_c('right-test-questions',{ref:"rightTestQuestion"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }